import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  getDoc,
  getDocs,
  onSnapshot,
  orderBy,
  query,
  updateDoc,
  where,
  Timestamp
} from 'firebase/firestore';
import { auth, db } from '../firebase';
import { TextField } from '@mui/material';
import moment from 'moment';

export default function Viewrequisition() {
  const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer)
      toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
  });

  const [userData, setUserData] = useState();
  const [loadincount, setloadincount] = useState(true);

  const [podatas, setpodatas] = useState([]);
  const [searchText, setsearchText] = useState("");

  const [updocid, setupdocid] = useState("");

  const [podate, setpodate] = useState(moment().format('YYYY-MM-DD'));
  const [billdate, setbilldate] = useState(moment().format('YYYY-MM-DD'));
  const [toname, settoname] = useState("");
  const [fromname, setfromname] = useState("");
  const [fromaddress, setfromaddress] = useState("");
  const [designation, setdesignation] = useState("");
  const [budgetamount, setbudgetamount] = useState("");
  const [approveamount, setapproveamount] = useState("");
  const [subject, setsubject] = useState("");

  useEffect(() => {
    if (searchText === '') {
      fetchData1()
    } else {
      fetchData2()
    }
  }, [searchText]);

  useEffect(() => {
    auth.onAuthStateChanged((user) => {
      setUserData(user);
      fetchPropid()
    });
  });

  const fetchPropid = async () => {
    if (userData) {
      if (loadincount) {
        const docRef = doc(db, "users", userData.uid)
        const docSnap = await getDoc(docRef)
        if (docSnap.exists()) {
          fetchData1();
          setloadincount(false)
        }
      }
    }
  }

  const fetchData1 = async () => {
    try {
      const q = query(
        collection(db, 'poregisters'),
        where('type', '==', 'Requisitions'),
        orderBy('podate', 'desc')
      );
      onSnapshot(q, (querySnapshot) => {
        setpodatas(querySnapshot.docs.map(doc => ({
          id: doc.id,
          data: doc.data()
        })));
      });
    } catch (error) {
      Toast.fire({ icon: "error", title: error.message });
    }
  }

  const fetchData2 = async () => {
    try {
      const filteredData = podatas.filter((item) =>
        item.data.subject.toUpperCase().includes(searchText.toUpperCase())
      );
      setpodatas(filteredData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  const handleDelete = async (docid) => {
    try {
      const poitemsQuery = query(collection(db, 'poitems'), where("poid", "==", docid));
      const poitemsSnapshot = await getDocs(poitemsQuery);
      const deletePromises = poitemsSnapshot.docs.map((doc) => deleteDoc(doc.ref));
      await Promise.all(deletePromises);

      await deleteDoc(doc(db, 'poregisters', docid));

      Toast.fire({ icon: "success", title: 'Requisitions and Related Items Deleted Successfully!!' });
      fetchData1();
    } catch (error) {
      Toast.fire({ icon: "error", title: 'Error deleting data. Please try again!' });
      console.error("Error deleting data:", error);
    }
  };

  const handleEdit = (id, podate, toname, fromname, fromaddress, designation, billdate, budgetamount, approveamount, subject) => {
    setupdocid(id);
    setpodate(podate)
    setbilldate(billdate)
    settoname(toname)
    setfromname(fromname)
    setfromaddress(fromaddress)
    setdesignation(designation)
    setbudgetamount(budgetamount)
    setapproveamount(approveamount)
    setsubject(subject)
  }

  const handleUpdate = async () => {
    await updateDoc(doc(db, "poregisters", updocid), {
      podate, toname, fromname, fromaddress, designation,
      billdate, budgetamount, approveamount, subject
    });
    Toast.fire({ icon: "success", title: 'Requisitions Updated Successfully!!' });
    fetchData1();
  }

  // ✅ Transfer Requisition -> Purchase Order
  const handleTransfer = async (reqId, reqData) => {
    try {
      // 1. Create new PO in poregisters
      const newPO = await addDoc(collection(db, "poregisters"), {
        ...reqData,
        type: "Purchase Order",
        createdAt: Timestamp.now()
      });

      // 2. Get all poitems for this requisition
      const poitemsQuery = query(collection(db, 'poitems'), where("poid", "==", reqId));
      const poitemsSnapshot = await getDocs(poitemsQuery);

      // 3. Copy poitems to new purchase order
      const addPromises = poitemsSnapshot.docs.map((docSnap) =>
        addDoc(collection(db, "poitems"), {
          ...docSnap.data(),
          poid: newPO.id
        })
      );

      await Promise.all(addPromises);

      Toast.fire({ icon: "success", title: "Requisition transferred to Purchase Order!" });
    } catch (error) {
      console.error("Transfer error:", error);
      Toast.fire({ icon: "error", title: "Error transferring requisition" });
    }
  };

  return (
    <div>
      <div className="content-wrapper">
        <br />
        <section className="content">
          <div className="container-fluid">
            <button className="btn btn-secondary " style={{ float: "right", textTransform: "uppercase" }} >|| View Requisition ||</button><br /><br /><br />
            <div className="card card-primary card-outline ex1">
              <div className=" p-1">
                <input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                  className='form-control col-sm-4' placeholder='Type here......' />
              </div>
              <div className="card-body table-responsive p-0" >
                <table className="table table-bordered table-hover table-striped table-head-fixed">
                  <thead>
                    <tr>
                      <th>Action</th>
                      <th>Sr No</th>
                      <th>Bill To </th>
                      <th>Requisition Date </th>
                      <th>Bill Date </th>
                      <th>Subject </th>
                      <th>Requisition Total </th>
                      <th>Budget Amount </th>
                      <th>Approve Amount </th>
                    </tr>
                  </thead>
                  <tbody>
                    {podatas.map((item, index) =>
                      <tr key={index}>
                        <td>
                          <a onClick={() => handleEdit(item.id, item.data.podate, item.data.toname, item.data.fromname, item.data.fromaddress, item.data.designation, item.data.billdate, item.data.budgetamount, item.data.approveamount, item.data.subject)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                          <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>&nbsp;
                          <a className="btn btn-sm bg-purple" href={'poitem-details/' + item.id} > <i className="fa fa-eye"></i></a>&nbsp;
                          <a className="btn btn-sm bg-teal" href={'print-requisitions/' + item.id} > <i className="fa fa-print"></i></a>&nbsp;
                          <a onClick={() => handleTransfer(item.id, item.data)} href='#0' className="btn btn-sm bg-orange"> <i className="fa fa-random"></i> Transfer</a>
                        </td>
                        <td width="80">{index + 1}</td>
                        <td>{item.data.toname}</td>
                        <td>
                          {item.data.podate &&
                            typeof item.data.podate === "string" &&
                            /^\d{4}-\d{2}-\d{2}$/.test(item.data.podate)
                            ? moment(item.data.podate, "YYYY-MM-DD").format("DD-MM-YYYY")
                            : ""}
                        </td>
                        <td>
                          {item.data.billdate &&
                            typeof item.data.billdate === "string" &&
                            /^\d{4}-\d{2}-\d{2}$/.test(item.data.billdate)
                            ? moment(item.data.billdate, "YYYY-MM-DD").format("DD-MM-YYYY")
                            : ""}
                        </td>

                        <td>{item.data.subject}</td>
                        <td>{item.data.pototal}</td>
                        <td>{item.data.budgetamount}</td>
                        <td>{item.data.approveamount}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Edit Modal */}
      <div className="modal fade" id="text-modal1">
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Requisitions</h4>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span></button>
            </div>
            <div className="modal-body">
              <div className='row'>
                <div className='col-sm-4'>
                  <div className='card'><div className="card-body">
                    <TextField type='text' className='form-control' value={fromname} onChange={(e) => setfromname(e.target.value)} label="From Name" size='small' /><br /><br />
                    <TextField type='text' className='form-control' value={fromaddress} onChange={(e) => setfromaddress(e.target.value)} label="From Address" size='small' /><br /><br />
                    <TextField className='form-control' color="secondary" label="Requisition Date" type='date' value={podate} onChange={(e) => setpodate(e.target.value)} size='small' /> <br /><br />
                  </div></div>
                </div>
                <div className='col-sm-4'>
                  <div className='card'><div className="card-body">
                    <TextField type='text' className='form-control' value={toname} onChange={(e) => settoname(e.target.value)} label="To Name" size='small' /> <br /><br />
                    <TextField type='text' className='form-control' value={designation} onChange={(e) => setdesignation(e.target.value)} label="Designation" size='small' /><br /><br />
                    <TextField className='form-control' color="secondary" label="Bill Date" type='date' value={billdate} onChange={(e) => setbilldate(e.target.value)} size='small' /><br /><br />
                  </div></div>
                </div>
                <div className='col-sm-4'>
                  <div className='card'><div className="card-body">
                    <TextField className='form-control' color="secondary" label="Budget Amount" type='text' value={budgetamount} onChange={(e) => setbudgetamount(e.target.value)} size='small' /><br /><br />
                    <TextField className='form-control' color="secondary" label="Approval Amount" type='text' value={approveamount} onChange={(e) => setapproveamount(e.target.value)} size='small' /><br /><br />
                    <TextField type='text' className='form-control' value={subject} onChange={(e) => setsubject(e.target.value)} label="Subject" /><br /><br />
                  </div></div>
                </div>
              </div>
            </div>
            <div className="modal-footer justify-content-between">
              <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
              <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
